var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3999 10V18.9211C19.3999 20.0693 18.7672 21 17.9857 21H6.81448C6.03303 21 5.3999 20.0693 5.3999 18.9211V10",
    fill: "#36AFC1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3999 10V18.9211C19.3999 20.0693 18.7672 21 17.9857 21H6.81448C6.03303 21 5.3999 20.0693 5.3999 18.9211V10",
    stroke: "#36AFC1",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.37793 11.6411L11.7498 3.26921C12.1089 2.91011 12.6908 2.91011 13.0499 3.26921L21.4218 11.6411",
    fill: "#36AFC1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.37793 11.6411L11.7498 3.26921C12.1089 2.91011 12.6908 2.91011 13.0499 3.26921L21.4218 11.6411",
    stroke: "#36AFC1",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeFilled);
export default __webpack_public_path__ + "static/media/home-filled.ca4285ee1a31f13ca8179d65ac3339cd.svg";
export { ForwardRef as ReactComponent };